
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-bc84bef4&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./LeaveMaster.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./LeaveMaster.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-bc84bef4!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./LeaveMaster.vue"),
  /* scopeId */
  "data-v-bc84bef4",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/microfinance/master/LeaveMaster.vue
// module id = 760
// module chunks = 0